var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pr-OutOfStock"},[_vm._v("\n  Out of Stock\n  "),_c('div',{staticClass:"pr-OutOfStock_Note"},[_vm._v("\n    Expected Restock:\n    "),(_vm.nextAvailableStock)?_c('span',[_vm._v(_vm._s(_vm.nextAvailableStock))]):_c('span',[_vm._v("Undetermined")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }